import React, { useState } from 'react'
import './App.css'
import Dashboard from './components/Dashboard'
import GoogleLogin from './components/GoogleLogin'

function App() {
  const [bypassAuth, setBypassAuth] = useState(true) // Temporarily bypass OAuth

  return (
    <div className="App">
      {bypassAuth ? (
        <Dashboard />
      ) : (
        <GoogleLogin />
      )}
      
      {/* Temporary bypass button */}
      <div style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 1000 }}>
        <button 
          onClick={() => setBypassAuth(!bypassAuth)}
          style={{
            padding: '10px 15px',
            background: bypassAuth ? '#f44336' : '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '12px'
          }}
        >
          {bypassAuth ? 'Enable OAuth' : 'Bypass OAuth'}
        </button>
      </div>
    </div>
  )
}

export default App 